
import React, { useEffect,useState} from 'react';
import $ from 'jquery'; // Import jQuery
import Slider from './Slider';
import Footer from './Footer';
import { Link } from 'react-router-dom';

function Topnavigation() {


	useEffect(() => {
		// Define the collapseNavbar function
		function collapseNavbar() {
		  if ($(".navbar").offset().top > 50) {
			$(".navbar-fixed-top").addClass("top-nav-collapse");
		  } else {
			$(".navbar-fixed-top").removeClass("top-nav-collapse");
		  }
		}
	
		// Call collapseNavbar on scroll
		$(window).scroll(collapseNavbar);
		// Call collapseNavbar on document ready
		$(document).ready(collapseNavbar);
	
		// Cleanup function
		return () => {
		  // Remove the scroll event listener when the component unmounts
		  $(window).off('scroll', collapseNavbar);
		};
	  }, []);

	  
	  const [isMobile, setIsMobile] = useState(false);
	  const handleToggleMobileClass = () => {
		setIsMobile(true); 
	  };
	
	  const handleToggleMobileClassM = () => {
		setIsMobile(false); 
	  };
	


  return (
    <>
	<div class="head_patch">
	<a href="javascript:;" id="click-a" onClick={handleToggleMobileClass}>≣</a>
			{/* <a href="#" id="click-a" class="close_menu"><i class="fa fa-times" aria-hidden="true"></i>sss </a> */}
			<p class="text-right"> Call Us : <a href="tel:7999061255"> 7999061255 </a>  </p>
	</div>
	<nav className={`navbar navbar-expand-lg navbar-fixed-top ${isMobile ? 'navbar-mobile' : ''}`}>
	
		<div class="container">
		<span id="click-m" onClick={handleToggleMobileClassM}> X </span>
			<a class="navbar-brand logo" href="/">
				<img src="assets/img/logo_1.png" className="img-fluid mx-auto d-block" width="70" alt="Study-Link Coaching Classes Indore"/>			
		    </a>
			<div class="navbar-collapse" id="navbarResponsive">
				<div class="top_menu">
					<ul>
						<li><a href="/"> Home </a></li>
						
					</ul>
					<ul class="call_us">
						<li> Call Us : <a href="tel:7999061255"> 7999061255 </a> </li>
					</ul>
				</div>
				<ul class="navbar-nav ml-auto">
					
					<li class="res_men"><a href="/"> Home </a></li>
					<li> <Link to="/about-us">About Us</Link></li>
					<li><Link to="/our-services">Our Services</Link></li>
					
					<li><Link to="/courses">Courses</Link></li>

					<li><Link to="/gallery">Gallery</Link></li>
					 
					
					<li><Link to="/contact-us">Contact us</Link></li>

					{/* <li><a href="#" class="online_add"> Online Admission </a></li> */}
									

				</ul>
			</div>
		</div>
	</nav>
	<script src='/assets/js/navigation.js'></script>
    </>
  );
}

export default Topnavigation;


